module.exports = __webpack_public_path__ + "static/fee04-193c61d4bbdfd85597a562a9a031d66a.png";